export default __webpack_public_path__ + "static/media/DFPKyoKaSho-W3.96455c24.woff";